<template>
  <div ref="trendLine" class="trend-line-report-section">
    <select-by-type :customSelected="metric"
                    textBeforeSelected="all customers"
                    textAfterSelected="by time"
                    @setDataType="setReportDataType"></select-by-type>

    <div v-if="errorText"
         v-html="errorText"
         class="error-label text-center">{{errorText}}</div>

    <line-graph v-if="graphData && wrapperWidth && !errorText"
                :dateTicks="dateTicks"
                :graphData="graphData"
                :toolTipContent="toolTipContent"
                :wrapperWidth="wrapperWidth"
                xSelector="date_time"
                ySelector="amount"
                @setToolTipContent="setToolTipContent"></line-graph>
  </div>
</template>

<script>
  import LineGraph from '../Graphs/LineGraph'
  import { NumberFormatters } from '../mixins/NumberFormatters'
  import Reports from '../mixins/Reports'
  import SelectByType from './SelectByType'
  import ToolTip from '../mixins/ToolTipContent'

  export default {
    props: {
      apiParams: Object,
      dateTicks: Array,
      error: String,
      graphData: Array,
      updating: Boolean,
      wrapperWidth: [Number, String],
    },

    name: 'TrendLineReport',

    components: {
      LineGraph,
      SelectByType,
    },

    mixins: [NumberFormatters, Reports, ToolTip],

    data() {
      return {
        delayedUpdate: {},
        errorMessage: null,
        graphParams: null,
        groupsWithSelected: null,
        openGroupItem: null,
        sectionOpen: false,
        selectedGroups: {},
        slideDown: false,
        toolTipContent: null,
        urlParams: null,
      }
    },

    methods: {
      loadGraphData() {
        this.$emit('loadGraphData', '/performance/trendline', 'trends', this.metric)
      },

      setReportDataType(dataType) {
        if (this.reportDataType !== dataType) {
          this.reportDataType = dataType
          this.loadGraphData()
        }
      },

      setToolTipContent(item) {
        this.toolTipContent = this.getToolTipContent(item, 'trends')
      },
    },

    created() {
      this.loadGraphData()
    },

    computed: {
      errorText: function() {
        const hasMulti = !!this.error && !!this.errorMessage
        return hasMulti ? `${this.error} <br /> ${this.errorMessage}` : this.error ? this.error : this.errorMessage
      },
    },

    watch: {
      apiParams: function() {
        this.loadGraphData()
      },
    },
  }
</script>

<style lang="sass">
  //
  //  trend line report
  //
  .trend-line-report-section
    position: relative

    .group-slide-down
      background: white
      position: absolute
      width: 45%
      z-index: 9

      &.slide-open
        border: 1px solid #128ff9
        border-radius: 8px
        overflow: auto

      .loading-icon
        margin: 1em auto
        opacity: 0.3
        width: 3rem
</style>